import { render, staticRenderFns } from "./IngredientsManagerForm.vue?vue&type=template&id=265a4800&"
import script from "./IngredientsManagerForm.vue?vue&type=script&lang=ts&"
export * from "./IngredientsManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports